import { ImageFragment } from '@/graphql/fragments/image';
import { gql } from '@apollo/client';

export const QUERY_EMOTION_WHEEL = gql`
  query emotionWHeel {
    emotionWheels {
      data {
        attributes {
          typeSection {
            type
            mainGradientFrom
            mainGradientTo
            secondaryGradientFrom
            secondaryGradientTo
          }
          emotion
          description

          L2 {
            emotion
            description
            L3 {
              emotion
              description
            }
            advice
            finalState {
              podcast {
                data {
                  attributes {
                    slug
                  }
                }
              }
              mindfulExercise {
                data {
                  attributes {
                    slug
                  }
                }
              }
              course {
                data {
                  attributes {
                    slug
                  }
                }
              }
              resource {
                data {
                  attributes {
                    slug
                  }
                }
              }
              redirectToCurrentInsight
              redirectToCurrentMindfulMinute
              redirectToCalendar
            }
          }
          overallMoodIcon {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;
export const QUERY_EMOTION_WHEEL_PAGE = gql`
  query emotionWHeelPage {
    emotionWheelPage {
      data {
        attributes {
          relatedContentTitle
          howAreYouFeelingTitle
          youAreTitle
          howAreYouTitle
          changeMyAnswerCta
          wellDoneTitle
          goToYourMoodTracker
          resetTheWheel
          messages {
            initial
            L1
            L2
            initialTitle
            L1Title
            L2Title
            privacyStatement
          }
          onboarding {
            steps {
              title
              description
              textBtn
              image {
                data {
                  ...ImageFragment
                }
              }
            }
          }
          calendarTitle
          bottomText
          EmotionNotFound {
            finalState {
              podcast {
                data {
                  attributes {
                    slug
                  }
                }
              }
              mindfulExercise {
                data {
                  attributes {
                    slug
                  }
                }
              }
              course {
                data {
                  attributes {
                    slug
                  }
                }
              }
              resource {
                data {
                  attributes {
                    slug
                  }
                }
              }
              redirectToCurrentInsight
              redirectToCurrentMindfulMinute
              redirectToCalendar
            }
            text
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
